import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

export async function createForm(formDataObj) {
  try {
    const encodedData = btoa(JSON.stringify(formDataObj));
    const fd = new FormData();
    fd.append("form_data", encodedData);

    const response = await axios.post(`${apiBaseUrl}form/create_form`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("createForm error:", error);
    return { status: false, type: "danger", success: "Failed to save form" };
  }
}

// 🔹 Get Forms List
export async function getForms(form_temp_by, page_no = "0", form_temp_status = "", search_key = "") {
  try {
    const fd = new FormData();
    fd.append("form_temp_by", form_temp_by);
    fd.append("page_no", page_no);
    fd.append("form_temp_status", form_temp_status);
    fd.append("search_key", search_key);

    const response = await axios.post(`${apiBaseUrl}form/get_forms`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("getForms error:", error);
    return { status: false, type: "danger", success: "Failed to load forms" };
  }
}

// 🔹 Get Form Report
export async function getFormReport(form_temp_by) {
  try {
    const fd = new FormData();
    fd.append("form_temp_by", form_temp_by);

    const response = await axios.post(`${apiBaseUrl}form/get_form_report`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("getFormReport error:", error);
    return { status: false, type: "danger", success: "Failed to load form report" };
  }
}

// 🔹 Delete Form
export async function deleteForm(form_temp_id) {
  try {
    const fd = new FormData();
    fd.append("form_temp_id", form_temp_id);

    const response = await axios.post(`${apiBaseUrl}form/delete_form`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("deleteForm error:", error);
    return { status: false, type: "danger", success: "Failed to delete form" };
  }
}

// 🔹 Update Form Status
export async function updateFormStatus(form_temp_id, form_temp_status) {
  try {
    const fd = new FormData();
    fd.append("form_temp_id", form_temp_id);
    fd.append("form_temp_status", form_temp_status);

    const response = await axios.post(`${apiBaseUrl}form/update_form_status`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("updateFormStatus error:", error);
    return { status: false, type: "danger", success: "Failed to update form status" };
  }
}
